import {
  GET_RESULTS_SUCCESS,
  GET_RESULTS_FAILURE,
  GET_RESULT_SUCCESS,
  DELETE_RESULT_SUCCESS,
  GET_SEGREGATIONS_SUCCESS,
  GET_ANALYTICAL_PRODUCTS_SUCCESS,
  GET_DEVOLUTION_PRODUCTS_SUCCESS,
  CHANGE_RECIPE_CFOP_SUCCESS,
  CHANGE_RECIPE_CFOP_FAILURE,
  ACCEPT_ROUDING_SUCCESS,
  ACCEPT_ROUDING_FAILURE,
  ACCEPT_DIVERGENCE_SUCCESS,
  ACCEPT_DIVERGENCE_FAILURE,
  SET_DISCOUNT_SUCCESS,
  SET_DISCOUNT_FAILURE,
  SET_FREIGHT_SUCCESS,
  SET_FREIGHT_FAILURE,
  SET_DEVOLUTION_SUCCESS,
  SET_DEVOLUTION_FAILURE,
  ACCEPT_DUPLICATED_SUCCESS,
  REPROCESS_RESULT_SUCCESS,
  SOLVE_MOVEMENT_SUCCESS,
  RESULTS_CLEAN,
  GET_REQUEST_RELATORIO_RESULTADO_PDF,
  GET_REQUEST_RELATORIO_RESULTADO_EXCEL,
  GET_REQUEST_RELATORIO_RESULTADO_PDF_FINISH,
  GET_REQUEST_RELATORIO_RESULTADO_EXCEL_FINISH,
  SET_ADDITION_SUCCESS,
  SET_ADDITION_FAILURE,
  SET_OUTRAS_DESPESAS_SUCCESS,
  SET_OUTRAS_DESPESAS_FAILURE,
  BLOCK_COMPETENCE_SUCCESS,
  BLOCK_COMPETENCE_FAILURE,
} from "../../../constants/actionTypes";
const INITIAL_STATE = {
  list: [],
  data: {},
  status: null,
  loadingExcel: false,
  loadingPDF: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_RESULTS_SUCCESS:
      return { ...state, list: action.payload };
    case GET_RESULTS_FAILURE:
      return { ...state, status: 400 };
    case GET_RESULT_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case DELETE_RESULT_SUCCESS:
      return { ...state, status: action.payload?.StatusCode };
    case BLOCK_COMPETENCE_SUCCESS:
      return { ...state, status: action.payload?.StatusCode };
    case BLOCK_COMPETENCE_FAILURE:
      return { ...state, status: 400 };
    case GET_SEGREGATIONS_SUCCESS:
      return { ...state, segregations: action.payload.Retorno };
    case GET_ANALYTICAL_PRODUCTS_SUCCESS:
      return { ...state, products: action.payload };
    case GET_DEVOLUTION_PRODUCTS_SUCCESS:
      return { ...state, productsDevolution: action.payload };
    case CHANGE_RECIPE_CFOP_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case CHANGE_RECIPE_CFOP_FAILURE:
      return { ...state, status: 400 };
    case ACCEPT_ROUDING_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case ACCEPT_ROUDING_FAILURE:
      return { ...state, status: 400 };
    case ACCEPT_DIVERGENCE_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case ACCEPT_DIVERGENCE_FAILURE:
      return { ...state, status: 400 };
    case SET_DISCOUNT_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case SET_DISCOUNT_FAILURE:
      return { ...state, status: 400 };
    case SET_FREIGHT_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case SET_FREIGHT_FAILURE:
      return { ...state, status: 400 };
    case SET_DEVOLUTION_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case SET_DEVOLUTION_FAILURE:
      return { ...state, status: 400 };
    case ACCEPT_DUPLICATED_SUCCESS:
      return { ...state, status: 200 };
    case REPROCESS_RESULT_SUCCESS:
      return { ...state, dataReprocess: action.payload };
    case SOLVE_MOVEMENT_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case RESULTS_CLEAN:
      return { ...state, data: {}, status: null };
    case GET_REQUEST_RELATORIO_RESULTADO_PDF:
      return { ...state, loadingPDF: true };
    case GET_REQUEST_RELATORIO_RESULTADO_EXCEL:
      return { ...state, loadingExcel: true };
    case GET_REQUEST_RELATORIO_RESULTADO_PDF_FINISH:
      return { ...state, loadingPDF: false };
    case GET_REQUEST_RELATORIO_RESULTADO_EXCEL_FINISH:
      return { ...state, loadingExcel: false };
    case SET_ADDITION_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case SET_ADDITION_FAILURE:
      return { ...state, status: 400 };
    case SET_OUTRAS_DESPESAS_SUCCESS:
      return { ...state, data: action.payload.Retorno };
    case SET_OUTRAS_DESPESAS_FAILURE:
      return { ...state, status: 400 };
    default:
      return state;
  }
};
